import { MaxWidth } from "shared/components/MaxWidth";
import { SMALL } from "shared/utils/constants";
import { useState, useEffect, useRef } from "react";
import styles from "./SurveyMonkeyEmbed.module.css";

export const SurveyMonkeyEmbedContainer = ({ src, size = SMALL }) => (
  <div className="SurveyMonkeyEmbedContainer">
    <MaxWidth size={size}>
      <SurveyMonkeyEmbed src={src} />
    </MaxWidth>
  </div>
);

export const SurveyMonkeyEmbed = ({ src }) => {
  const [mounted, setMounted] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || mounted) {
      return;
    }

    window.SMCX = window.SMCX || [];
    const script = document.createElement("script");

    Object.assign(script, {
      async: true,
      id: "smcx-sdk",
      src,
      type: "text/javascript",
    });

    containerRef.current.appendChild(script);

    setMounted(true);
  }, [containerRef, mounted]);

  return <div className={styles.container} ref={containerRef} />;
};
